import { BodyText } from '@policygenius/mortar';

import Modal from 'components/Modal';

import { CONTENT, DeclinedConditions, NAME, SORRY_NOTE, TITLE } from './constants';

const DeclinedConditionsModal = ({
  condition,
  setDeclinedCondition,
}: {
  condition: DeclinedConditions | undefined;
  setDeclinedCondition(state: DeclinedConditions | undefined): void;
}) => {
  const closeModal = () => setDeclinedCondition(undefined);

  return (
    <Modal
      title={`${TITLE} ${condition}`}
      primaryCTA={{ text: 'Got it', onClick: closeModal }}
      name={NAME}
      onRequestClose={closeModal}
      showModal={!!condition}
    >
      <BodyText size="large">
        {CONTENT} {condition}.
      </BodyText>
      <br />
      <BodyText size="large">{SORRY_NOTE}</BodyText>
    </Modal>
  );
};

export default DeclinedConditionsModal;
